import React, { Component } from 'react';
import { observer, inject } from "mobx-react";
import { NavbarLogoContainer } from './styles';
import { RouterStore } from "mobx-react-router";
import { computed } from "mobx";
import { IThemesStore } from "@src/Stores/Themes/types";

interface IProps {
    routing?: RouterStore;
    themes?: IThemesStore;
  }

@inject("routing", "themes")
@observer
export default class NavbarLogo extends Component<IProps> {
    goToMain = () => {
        this.props.routing.history.push("/");
      };
    
      @computed get applicationLogo() {
        return this.props.themes.application.applicationThemeDetails
          .applicationLogoImageUrl;
      }

    render() {      
      const defaultLogo = this.props.themes.application.isNightTheme ? "/images/maranics_logo_white.png" : "/images/maranics_logo_dark.png";
      return (
          <NavbarLogoContainer onClick={this.goToMain}>
              <img src={this.applicationLogo || defaultLogo} alt={"Maranics logo"} />
          </NavbarLogoContainer>
      );
    }
}